import { Pipe, PipeTransform } from '@angular/core';

/**
 * An unused pipe which currently returns `null` in all cases.
 */
@Pipe({
  name: 'bookLogoAlt'
})
export class BookLogoAltPipe implements PipeTransform {

  /**
   * An unused pipe which currently returns `null` in all cases.
   * @param value unused
   * @param args unused
   * @returns `null` in all cases, for now.
   */
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
